import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Dynamically updates the iOS Smart App Banner's app-argument
 * to preserve deep link context when opening the native app.
 *
 * This allows users to land on the same content in the app
 * that they were viewing on the web.
 */
export const useSmartAppBanner = () => {
  const location = useLocation();
  const { pathname, search } = location;

  useEffect(() => {
    // Construct the full URL for app-argument
    const baseUrl = window.location.origin;
    const fullPath = `${pathname}${search}`;
    const appArgument = `${baseUrl}${fullPath}`;

    // Find the Smart App Banner meta tag
    const metaTag = document.querySelector('meta[name="apple-itunes-app"]');

    if (metaTag) {
      // Update the content with app-argument
      const baseContent = 'app-id=1550239863';
      metaTag.setAttribute('content', `${baseContent}, app-argument=${appArgument}`);
    }
  }, [pathname, search]);
};

export default useSmartAppBanner;
